import { FormGroup, AbstractControl } from '@angular/forms';
import { RegExValidation } from '../constants/regex-validation.constants';

// custom validator to check that two fields match
export class InputValidationService {

    static isValidMobile(control: AbstractControl) {
        const value = (control.value || '').toString();
        if (value.length !== 10) {
            // return if another validator has already found an error on the matchingControl
            return null;
        }

        // set error on matchingControl if validation fails
        if (!(RegExValidation.cellNumber.test(control.value))) {
            return { isValidMobile: true };
        } else {
            return null;
        }
    }

    static isValidIdNumber(control: AbstractControl) {
        const value = control.value ? control.value.toString() : '';
        if (value.length !== 13) {
            // return if another validator has already found an error on the matchingControl
            return null;
        }

        if (value.length === 0) { return { isValidIdNumber: true }; }

        const yearStr = value.substring(0, 2);
        const monthStr = value.substring(2, 4);
        const dayStr = value.substring(4, 6);

        // Convert 2-digit year to 4-digit year
        // SA ID numbers: 00-21 = 2000-2021, 22-99 = 1922-1999
        const currentYear = new Date().getFullYear();
        const currentYearLastTwoDigits = currentYear % 100;
        let fullYear: number;
        
        const twoDigitYear = Number.parseInt(yearStr, 10);
        if (twoDigitYear <= currentYearLastTwoDigits) {
            fullYear = 2000 + twoDigitYear;
        } else {
            fullYear = 1900 + twoDigitYear;
        }

        const month = Number.parseInt(monthStr, 10);
        const day = Number.parseInt(dayStr, 10);

        if (month < 1 || month > 12) {
            return { isValidIdNumber: true };
        }

        if (day < 1 || day > 31) {
            return { isValidIdNumber: true };
        }

        // handles leap years
        const tempDate = new Date(fullYear, month - 1, day);
        
        if (tempDate.getFullYear() !== fullYear || 
            tempDate.getMonth() !== (month - 1) || 
            tempDate.getDate() !== day) {
            return { isValidIdNumber: true };
        }

        // Apply Luhn Algorithm for check-digits
        let tempTotal = 0;
        let checkSum = 0;
        let multiplier = 1;
        for (let i = 0; i < 13; ++i) {
            tempTotal = Number.parseInt(value.charAt(i)) * multiplier;
            if (tempTotal > 9) {
                tempTotal = Number.parseInt(tempTotal.toString().charAt(0)) + Number.parseInt(tempTotal.toString().charAt(1));
            }
            checkSum = checkSum + tempTotal;
            multiplier = (multiplier % 2 === 0) ? 1 : 2;
        }
        
        if ((checkSum % 10) !== 0) { 
            return { isValidIdNumber: true }; 
        }

        return null;
    }

    static passwordMustMatch(controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];

            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                // return if another validator has already found an error on the matchingControl
                return;
            }

            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ mustMatch: true });
            } else {
                matchingControl.setErrors(null);
            }
        };
    }

    static isValidEmail(control: AbstractControl) {
        const value = (control.value || '').toString();
        if (value.length === 0) {
            // return if another validator has already found an error on the matchingControl
            return null;
        }

        // set error on matchingControl if validation fails
        if (!(RegExValidation.email.test(value))) {
            return { isValidEmail: true };
        } else {
            return null;
        }
    }

    static isNumericWithoutDecimal(control: AbstractControl) {
        const value = (control.value || '').toString();
        if (value.length === 0) {
            // return if another validator has already found an error on the matchingControl
            return null;
        }

        // set error on matchingControl if validation fails
        if ((RegExValidation.numericWithoutDecimal.test(value))) {
            return { isNumericWithoutDecimal: true };
        } else {
            return null;
        }
    }

}
